import MyReports from './MyReports';

export default MyReports;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/my-reports/index.js